<template>
  <div :class="['slideshow-box', boxClass]">
    <div class="swiper-wrapper">
      <ul
        class="swiper-slide"
        v-for="(item, index) in bannerList"
        :key="item.id || item + index"
      >
        <img :src="getImageUrl(item)" alt="" />
      </ul>
    </div>
    <div class="swiper-pagination" v-if="pagination" />
    <div
      class="swiper-button-prev"
      style="width: 50px; height: 50px"
      v-if="navigation"
    />
    <div
      class="swiper-button-next"
      style="width: 50px; height: 50px"
      v-if="navigation"
    />
  </div>
</template>

<script>
import Swiper from "swiper";
import "swiper/css/swiper.min.css";
import { getImageUrl } from "@/utils/tool";
export default {
  name: "slideshow",
  props: {
    // 轮播图数据
    bannerList: {
      type: Array,
      default: () => [],
    },
    // 轮播图类名
    boxClass: {
      type: String,
      default: "slideshow",
    },
    // 是否循环播放
    loop: {
      type: Boolean,
      default: false,
    },
    // 是否自动播放
    autoplay: {
      type: Boolean,
      default: false,
    },
    // 是否显示分页器
    pagination: {
      type: Boolean,
      default: true,
    },
    // 是否显示左右箭头
    navigation: {
      type: Boolean,
      default: true,
    },
    // 滑动方向
    direction: {
      type: String,
      default: "horizontal",
    },
  },
  data() {
    return { mySwiper: null };
  },
  mounted() {
    // this.isCallSwiper();
  },
  methods: {
    getImageUrl,
    initSwiper() {
      let { boxClass, loop, autoplay, direction } = this;
      this.mySwiper = new Swiper("." + boxClass, {
        observer: true,
        observeParents: true,
        loop,
        autoplay,
        direction,
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
      });
    },
    isCallSwiper() {
      setTimeout(() => {
        this.initSwiper();
      }, 50);
    },
  },
};
</script>

<style lang="scss" scoped>
// 轮播默认样式
.slideshow-box {
  width: 100%;
  height: 100%;
  overflow: hidden;
  transition: 0.3s;
  position: relative;

  /* 设置轮播图左右箭头 */
  .swiper-button-next {
    right: -50px;
  }
  .swiper-button-prev {
    left: -50px;
  }
  .swiper-button-next,
  .swiper-button-prev {
    background-color: rgba(23, 22, 24, 0.315);
    border-radius: 50%;
    transition: 0.3s;
    opacity: 0;
  }
  .swiper-button-next:after,
  .swiper-button-prev:after {
    font-size: 18px;
    color: rgba(255, 255, 255, 0.466);
  }
  .swiper-button-next:hover,
  .swiper-button-prev:hover {
    background-color: rgba(15, 15, 15, 0.644);
  }
  .swiper-button-next:hover.swiper-button-next:after,
  .swiper-button-prev:hover.swiper-button-prev:after {
    color: rgb(255, 255, 255);
  }
}
.slideshow-box:hover > .swiper-button-next {
  opacity: 1;
  right: 10px;
}
.slideshow-box:hover > .swiper-button-prev {
  opacity: 1;
  left: 10px;
}
</style>

<style>
/* 首页banner分页样式 */
.banner .swiper-pagination-bullet {
  width: 40px;
  height: 2px;
  background-color: #ffffff;
  opacity: 1;
}
.banner .swiper-pagination-bullet-active {
  background-color: #0073d3;
}
</style>
